const WAVE_CLASS_NAME = 'Program';
const WAVE_CANVAS_ID = 'wave-engine';

export { WAVE_CLASS_NAME, WAVE_CANVAS_ID };
